<div class="page">
    <div class="card-validacion">
        <div class="brand">
            <app-logo Width="48" Height="48"></app-logo>
            <div>
                <span class="brand-title">CCDH</span>
                <span class="brand-sub">Validación de ticket de votación</span>
            </div>
        </div>

        <div *ngIf="estado=='cargando'" class="estado">
            <span class="spinner" aria-hidden="true"></span>
            <p class="estado-texto">Validando ticket…</p>
        </div>

        <div *ngIf="estado=='invalido'" class="estado">
            <span class="icono icono-error" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </span>
            <h1 class="estado-titulo">Ticket no válido</h1>
            <p class="estado-texto">No se encontró un ticket de votación con este código.</p>
        </div>

        <ng-container *ngIf="estado=='valido'">
            <div class="estado">
                <span class="icono icono-ok" aria-hidden="true">
                    <svg width="28" height="28" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                    </svg>
                </span>
                <h1 class="estado-titulo">Ticket válido</h1>
                <p class="estado-texto">Ticket No. {{data[0]['idTicket']}}</p>
            </div>

            <dl class="detalle">
                <div>
                    <dt>Fecha</dt>
                    <dd>{{data[0]['fechaVotacion'] | date: 'dd/MM/yyyy' : 'UTC'}}</dd>
                </div>
                <div>
                    <dt>Hora</dt>
                    <dd>{{data[0]['horaVotacion']}}</dd>
                </div>
                <div>
                    <dt>Votos</dt>
                    <dd>{{data.length}}</dd>
                </div>
                <div>
                    <dt>Atendido en</dt>
                    <dd>{{data[0]['usuario']}}</dd>
                </div>
            </dl>

            <div class="votantes">
                <span class="votantes-titulo">Votantes</span>
                <ul>
                    <li *ngFor="let d of data">{{d['nombreCompleto']}}</li>
                </ul>
            </div>
        </ng-container>
    </div>
</div>
